module.exports = __webpack_public_path__ + "img/GB-WLS.3866f1f6.png";